<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>จัดการห้องประชุม</span>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around mt-6>
      <v-flex
        xs4
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;"
      >
        <v-layout>
          <v-flex
            shrink
            d-flex
            align-center
            style="color: black;font-size: 18px;"
          >
            <span><b>Filter</b></span>
          </v-flex>
          <v-flex xs6 mx-3 d-flex align-center justify-start>
            <v-select
              @input="searchYear"
              class="style-chooser"
              style="width: 100%;"
              :options="years"
              v-model="year_search"
            />
          </v-flex>
          <v-flex
            shrink
            d-flex
            align-center
            style="color: black;font-size: 18px;"
          >
            <span><b>ปี</b></span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex justify-end align-center>
        <v-btn :disabled="user.currentRole === 3" color="#3E7662" dark @click="$router.push('/create-meeting')">
          <span class="mr-2">สร้างการประชุม</span>
          <v-icon>add_box</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- Table -->
    <v-layout mt-8>
      <v-flex>
        <form-table
          :headers="headers"
          :items="meetingList"
          onEditMeeting
          onViewMeeting
        ></form-table>
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateMeeting.last_page"
          :total-visible="9"
          @input="getMeetingList"
          v-model="paginateMeeting.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import FormTable from "../../components/table/FormTable";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState, mapActions } from "vuex";
export default {
  name: "Meeting",
  components: {
    FormTable,
    vSelect,
    Loading,
  },
  computed: {
    years() {
      this.year = new Date().getFullYear();
      return Array.from(
        { length: this.year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    paginateMeeting: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    year: "",
    year_search: "",
    headers: [
      { text: "ลำดับ", value: "number", align: "center" },
      { text: "ชื่อการประชุม", value: "meetingName", align: "center" },
      { text: "รอบ/วันที่การประชุม", value: "meetingDate", align: "center" },
      { text: "เวลา", value: "time", align: "center" },
      { text: "สถานที่", value: "location", align: "center" },
      { text: "จัดการ", value: "edit_meeting", align: "center" },
      { text: "ดูข้อมูล", value: "view_meeting", align: "center" },
    ],
    meetingList: [],
  }),
  created() {
    // Check Permission Access
    //  if (this.user.currentRole !== 1) {
    //      this.$router.go(-1);
    //  }
    this.getMeetingList(1);
  },
  methods: {
    searchYear() {
      this.isLoading = true;
      this.meetingList = [];
      let data = {
        year: this.year_search,
        page: 1,
      };
      if (this.year_search === null) {
        this.getMeetingList();
      } else {
        this.$store
          .dispatch("Meeting/filterMeeting", data)
          .then((res) => {
            let i = 1;
            res.data.forEach((data) => {
              this.meetingList.push({
                number: i,
                meetingName: data.meetingName,
                meetingDate:
                  "รอบที่ " + data.meetingNumber + " / " + data.meetingDate,
                time: data.meetingTime,
                id: data.id,
                location: data.meetingPlace,
                linkEdit: "EditMeeting",
                linkView: "ViewDataMeeting",
                currentRole: this.user.currentRole
              });
              i++;
            });
            this.paginateMeeting.current_page = res.current_page;
            this.paginateMeeting.from = res.from;
            this.paginateMeeting.last_page = res.last_page;
            this.paginateMeeting.per_page = res.per_page;
            this.paginateMeeting.total = res.total;
            this.paginateMeeting.to = res.to;
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });
      }
    },
    getMeetingList(page) {
      this.isLoading = true;
      this.meetingList = [];
      this.$store
        .dispatch("Meeting/getAllMeetingList", page)
        .then((res) => {
          let i = 1;
          res.data.forEach((data) => {
            this.meetingList.push({
              number: i,
              meetingName: data.meetingName,
              meetingDate:
                "รอบที่ " + data.meetingNumber + " " + data.meetingDate,
              time: data.meetingTime,
              id: data.id,
              location: data.meetingPlace,
              linkEdit: "EditMeeting",
              linkView: "ViewDataMeeting",
              currentRole: this.user.currentRole
            });
            i++;
          });
          this.paginateMeeting.current_page = res.current_page;
          this.paginateMeeting.from = res.from;
          this.paginateMeeting.last_page = res.last_page;
          this.paginateMeeting.per_page = res.per_page;
          this.paginateMeeting.total = res.total;
          this.paginateMeeting.to = res.to;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__selected
        /*.style-chooser .vs__dropdown-menu:hover*/
 {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
